<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <Subject :type='type'></Subject>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import Subject from '@/components/subject'
export default {
  data () {
    return {
      navBlock: '社區  /  話題列表',
      navtitle:'新增話題',
      type: 'add',
    }
  },
  components: {
    NavBar,
    Subject
  }
};
</script>>



// WEBPACK FOOTER //
// src/pages/community/addSubject.vue